export const routes = {
  home: '/',
  realizations: '/realizations',
  contact: '/contact',
};
